import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/test-form")({
  component: TestForm,
});

function TestForm() {
  return (
    <div style={{ padding: 24, fontFamily: "sans-serif" }}>
      <h1>Test Form (diagnóstico)</h1>
      <p>Formulario HTML puro, sin React state, sin librerías.</p>
      <form>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="n">Nombre</label><br />
          <input id="n" type="text" name="nombre" style={{ padding: 8, border: "1px solid #ccc", width: 280 }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="e">Email</label><br />
          <input id="e" type="email" name="email" style={{ padding: 8, border: "1px solid #ccc", width: 280 }} />
        </div>
        <div style={{ marginBottom: 12 }}>
          <label htmlFor="m">Mensaje</label><br />
          <textarea id="m" name="mensaje" rows={4} style={{ padding: 8, border: "1px solid #ccc", width: 280 }} />
        </div>
        <button type="submit" style={{ padding: "8px 16px" }}>Enviar</button>
      </form>
    </div>
  );
}